import React, { ReactNode } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { BoxComponent } from '../box/Box';
import { SxProps, Theme } from '@mui/material';

export const ButtonComponent = ({
  children,
  onClick,
  variant,
  types,
  backgroundColor,
  size,
  sx,
  disabled,
  loaderContainedbtn,
  buttonSx,
  textStyles,
  ...otherProps
}: ButtonComponentProps) => {
  return (
    <Button
      onClick={onClick}
      sx={
        {
          ...(variant === 'contained'
            ? loaderContainedbtn
              ? btnStyles.loaderContainedbtn
              : btnStyles.containedBtn
            : variant === 'outlined'
            ? btnStyles.outlinedBtn
            : sx),
          ...buttonSx,
        } as SxProps<Theme>
      }
      {...otherProps}
      size={size}
      variant={variant}
      disabled={disabled}
    >
      {variant ? <BoxComponent sx={textStyles}>{children}</BoxComponent> : children}
    </Button>
  );
};

const baseContainedBtn = {
  height: '44px',
  padding: '10px 20px',
  textTransform: 'none',
  color: 'secondary.light',
  borderRadius: '8px',
  backgroundColor: 'primary.dark',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: 'primary.dark',
  },
  '&:active': {
    backgroundColor: 'primary.dark',
  },
};

const btnStyles = {
  outlinedBtn: {
    height: '44px',
    width: 'auto',
    padding: '10px 20px 10px 20px',
    color: 'primary.dark',
    backgroundColor: 'transparent',
    textTransform: 'none',
    border: '1px solid #e36720',
    borderRadius: '8px',
  },
  containedBtn: {
    ...baseContainedBtn,
    '&.Mui-disabled': {
      backgroundColor: 'grey.400',
    },
  },

  loaderContainedbtn: {
    ...baseContainedBtn,
    '&.Mui-disabled': {
      backgroundColor: 'primary.dark',
    },
  },
};

interface ButtonComponentProps extends Omit<ButtonProps, 'children'> {
  textStyles?: SxProps<Theme>;
  /**
   * Is this the principal call to action on the page?
   */
  primary?: boolean;
  /**
   * What background color to use
   */
  backgroundColor?: string;
  /**
   * How large should the button be?
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Button contents
   */
  label?: string;
  /**
   * Optional click handler
   */
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children: ReactNode;
  variant?: 'contained' | 'outlined' | 'text';
  types?: 'save' | 'cancel' | undefined;
  loaderContainedbtn?: boolean;
  buttonSx?: SxProps<Theme>;
}
